import { IRenderFormField, ISelectOption } from "src/@types/form";
import { SingleSelectField } from "src/components/FormField/SingleSelectField";
import { TextField } from "src/components/FormField/TextField";
import { formFieldTrns } from "src/components/FormField/trns";
import { Roles } from "src/@types/users";
import { contactUsRoleOptionsTrns } from "../trns";
import { ContactUsFormFields } from "../types";

export const ROLE_OPTIONS: ISelectOption[] = [
  {
    label: { i18nKey: contactUsRoleOptionsTrns.agent },
    id: Roles.AGENT,
    value: Roles.AGENT,
  },

  {
    label: { i18nKey: contactUsRoleOptionsTrns.owner },
    id: Roles.OWNER,
    value: Roles.OWNER,
  },
  {
    label: { i18nKey: contactUsRoleOptionsTrns.other },
    id: "other",
    value: "other",
  },
];

const DEFAULT_ERROR_CLASSNAME = "absolute -bottom-5 lg:-bottom-6";

export const getContactUsFormField = (
  countries: ISelectOption[]
): IRenderFormField[] => [
  {
    name: ContactUsFormFields.name,
    label: { i18nKey: formFieldTrns.yourName },
    component: TextField,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    name: ContactUsFormFields.email,
    type: "email",
    label: { i18nKey: formFieldTrns.yourEmail },
    component: TextField,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    name: ContactUsFormFields.phone,
    type: "tel",
    label: { i18nKey: formFieldTrns.yourPhone },
    component: TextField,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    name: ContactUsFormFields.country,
    label: { i18nKey: formFieldTrns.yourCountry },
    options: countries,
    component: SingleSelectField,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    name: ContactUsFormFields.role,
    label: { i18nKey: formFieldTrns.iAm },
    options: ROLE_OPTIONS,
    component: SingleSelectField,
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
  {
    name: ContactUsFormFields.howWeCanHelp,
    label: { i18nKey: formFieldTrns.howWeCanHelp },
    component: TextField,
    isTextArea: true,
    className: "min-h-40",
    errorClassName: DEFAULT_ERROR_CLASSNAME,
  },
];
